const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBusinessInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5 10V17.6C5 18.4401 5 18.8601 5.16349 19.181C5.3073 19.4632 5.53677 19.6927 5.81901 19.8365C6.13988 20 6.55992 20 7.4 20H12.6C13.4401 20 13.8601 20 14.181 19.8365C14.4632 19.6927 14.6927 19.4632 14.8365 19.181C15 18.8601 15 18.4401 15 17.6V14",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M3.57889 8.84223L5.55777 4.88446C5.7183 4.5634 5.79857 4.40287 5.91831 4.28558C6.02421 4.18187 6.15184 4.10299 6.29196 4.05465C6.45042 4 6.6299 4 6.98885 4H17.0111C17.3701 4 17.5496 4 17.708 4.05465C17.8482 4.10299 17.9758 4.18187 18.0817 4.28558C18.2014 4.40287 18.2817 4.56339 18.4422 4.88445L18.4422 4.88446L20.4211 8.84223C20.6128 9.22559 20.7086 9.41727 20.6856 9.57308C20.6655 9.70914 20.5903 9.8309 20.4776 9.90973C20.3485 10 20.1342 10 19.7056 10H4.29443C3.86582 10 3.65151 10 3.52245 9.90973C3.40974 9.8309 3.33449 9.70914 3.31439 9.57308C3.29137 9.41727 3.38721 9.22559 3.57889 8.84223Z",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M19 10V20",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M5 16H15",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessInfo);
export default __webpack_public_path__ + "static/media/icon_business_info.4cb3db166a28984e90d65c585d521118.svg";
export { ForwardRef as ReactComponent };